import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/mobile-nav-header-link';
import { MobileNavHeaderLinkModule } from '@upr-web-primer/mobile-nav-header-link';
import { CommonModule } from '@angular/common';

class NavPackagesTicketsMobileDialogComponent {
    constructor() { }
}
NavPackagesTicketsMobileDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavPackagesTicketsMobileDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NavPackagesTicketsMobileDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: NavPackagesTicketsMobileDialogComponent, selector: "upr-nav-packages-tickets-mobile-dialog", inputs: { data: "data" }, ngImport: i0, template: "<upr-mobile-nav-header-link [link]=\"data\"> </upr-mobile-nav-header-link>\r\n", styles: [""], components: [{ type: i1.MobileNavHeaderLinkComponent, selector: "upr-mobile-nav-header-link", inputs: ["link"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavPackagesTicketsMobileDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-nav-packages-tickets-mobile-dialog', template: "<upr-mobile-nav-header-link [link]=\"data\"> </upr-mobile-nav-header-link>\r\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { data: [{
                type: Input
            }] } });

class NavPackagesTicketsMobileDialogModule {
}
NavPackagesTicketsMobileDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavPackagesTicketsMobileDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavPackagesTicketsMobileDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavPackagesTicketsMobileDialogModule, declarations: [NavPackagesTicketsMobileDialogComponent], imports: [CommonModule, MobileNavHeaderLinkModule], exports: [NavPackagesTicketsMobileDialogComponent,
        CommonModule,
        MobileNavHeaderLinkModule] });
NavPackagesTicketsMobileDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavPackagesTicketsMobileDialogModule, providers: [], imports: [[CommonModule, MobileNavHeaderLinkModule], CommonModule,
        MobileNavHeaderLinkModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavPackagesTicketsMobileDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NavPackagesTicketsMobileDialogComponent],
                    imports: [CommonModule, MobileNavHeaderLinkModule],
                    providers: [],
                    exports: [
                        NavPackagesTicketsMobileDialogComponent,
                        CommonModule,
                        MobileNavHeaderLinkModule
                    ]
                }]
        }] });

export { NavPackagesTicketsMobileDialogComponent, NavPackagesTicketsMobileDialogModule };
